module.exports = __webpack_public_path__ + "img/Organisatorischer_Leiter_Rettungsdienst.31503230.svg";